// extracted by mini-css-extract-plugin
export var branchTable = "styles-module--branchTable--2yrIl";
export var tableLink = "styles-module--tableLink--3lWgQ";